module.exports = __webpack_public_path__ + "img/sidebar_back.24d34b01.png";